<template>
  <div v-if="flagStale && staleCount > 0" class="iv-stale-banner">
    <span class="iv-stale-icon">
      <i class="fa fa-clock-o" aria-hidden="true"></i>
    </span>
    <div class="iv-stale-text">
      <div class="iv-stale-title">Needs re-verification</div>
      <div class="iv-stale-sub">
        {{ staleCount }} {{ staleCount === 1 ? 'patient' : 'patients' }} in this range
        {{ staleCount === 1 ? 'was' : 'were' }} last verified {{ staleDays }}+ days ago.
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'StaleBanner',
  props: {
    // From the dashboard payload's `staleCount` (already respects the site's
    // flagStale setting server-side — it is only incremented for stale rows).
    staleCount: {
      type: Number,
      default: 0,
    },
    // The site's staleDays setting (Slice 6c), from the Precheck settings blob.
    staleDays: {
      type: Number,
      default: 30,
    },
    // The site's flagStale setting (Slice 6c). When off, the banner is hidden
    // entirely (the dashboard's staleCount is already 0 server-side, but this
    // keeps the UI honest even if a stale count ever leaks through).
    flagStale: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.iv-stale-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 18px;
  background: #fdeeee;
  border-bottom: 1px solid #dfe4e3;
}

.iv-stale-icon {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: #e5484d;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  font-size: 15px;
}

.iv-stale-title {
  font-weight: 700;
  font-size: 14px;
  color: #a5292e;
}

.iv-stale-sub {
  font-size: 12.5px;
  color: #b04a4e;
}
</style>
